module.exports = __webpack_public_path__ + "img/add-user-black.687792a6.svg";